export default __webpack_public_path__ + "static/media/orangeOrbPullQuote1.2f938f0f.svg";